import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { internalSelectionMenuInjectionKey as s } from "./interface.js";
import { render as a } from "../../../_utils/vue/render.js";
import { defineComponent as p, inject as c, h as f } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const v = p({
  name: "NBaseSelectGroupHeader",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    tmNode: {
      type: Object,
      required: !0
    }
  },
  setup() {
    const {
      renderLabelRef: d,
      renderOptionRef: n,
      labelFieldRef: o,
      nodePropsRef: r
    } = c(s);
    return {
      labelField: o,
      nodeProps: r,
      renderLabel: d,
      renderOption: n
    };
  },
  render() {
    const {
      clsPrefix: d,
      renderLabel: n,
      renderOption: o,
      nodeProps: r,
      tmNode: {
        rawNode: e
      }
    } = this, t = r == null ? void 0 : r(e), l = n ? n(e, !1) : a(e[this.labelField], e, !1), i = f("div", Object.assign({}, t, {
      class: [`${d}-base-select-group-header`, t == null ? void 0 : t.class]
    }), l);
    return e.render ? e.render({
      node: i,
      option: e
    }) : o ? o({
      node: i,
      option: e,
      selected: !1
    }) : i;
  }
});
export {
  v as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/select-menu/src/SelectGroupHeader.js
// module id = 1563
// module chunks = 41